<script setup lang="ts" generic="Value">
import {
  EnumerationOptionDto,
  EnumerationValueDto,
  type EnumerationValueDtoValue,
} from '@/api/generator';
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import { EnumerationValueProps } from '@/components/forms/types.ts';
import { I18nKey } from '@/utils/typings.ts';
import { useTranslation } from 'i18next-vue';
import { computed, ref } from 'vue';

const props = defineProps<EnumerationValueProps<Value>>();

const enumerationValue = defineModel<EnumerationValueDto>('enumerationValue', {
  required: true,
});

const { t } = useTranslation();

const emits = defineEmits<{
  blur: [event: FocusEvent];
}>();

const value = ref<EnumerationValueDtoValue | null | undefined>(enumerationValue.value.value);

const selectOptions = computed(() => {
  return enumerationValue.value?.options?.map((option) => {
    return {
      title: `${t(option.name as I18nKey)}`,
      value: option,
    };
  });
});

function onUpdate(input: EnumerationOptionDto | null | undefined) {
  // set to 'undefined' in case of 'null', to make the 'required' field validation working
  value.value = input || undefined;
  enumerationValue.value = {
    ...enumerationValue.value,
    value: input || undefined,
  };
}
</script>

<template>
  <Autocomplete
    v-bind="props"
    :items="props.items ? props.items : selectOptions"
    :modelValue="value"
    :multiple="false"
    @update:modelValue="onUpdate"
    @blur="emits('blur', $event)"
  />
</template>
